import _ElementUI2 from "element-ui/lib/theme-chalk/index.css";
import _ElementUI from "element-ui/lib";
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store'; // TODO 需要自适应可放开
// import '@/utils/rem.js'
import { fetch } from '@/utils/axios';
import { utils } from '@/utils/utils';
import 'windi.css';
import 'element-ui/lib/theme-chalk/index.css';
Vue.prototype.$fetch = fetch;
Vue.prototype.$utils = utils;
Vue.config.productionTip = false;
Vue.use(_ElementUI);
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');